import styled from 'styled-components'

const ProductCarouselImageContainerUi = styled.img`
  border-radius: 8px;
  height: 100%;
  width: 100%;
`

export default ProductCarouselImageContainerUi
